module.exports = __webpack_public_path__ + "static/media/thumb-otelo.0a6be104.svg";